export default __webpack_public_path__ + "static/media/case_manager.96ee64d3.png";